/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import {
    object,
    bool,
} from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import CurrentProduct from './CurrentProduct';

const useStyle = makeStyles((theme) => ({
    addonWrapper: {
        margin: '0 auto',
        width: '100%',
        paddingBottom: '40px',
        [theme?.breakpoints?.down('600')]: {
            paddingBottom: '16px',
        },
    },
    titleProd: {
        lineHeight: '26px',
        fontSize: '18px',
        color: '#21571D',
        textAlign: 'center',
        fontFamily: 'LatoBold',
        '& strong': {
            display: 'flex',
            alignItems: 'center',
        },
    },
    productDetail: {
        marginTop: '16px',
    },
    iconCheck: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: '14px',
        [theme?.breakpoints?.down('600')]: {
            paddingLeft: '8px',
        },
    },
}));

const AddonProductInfoUI = ({
    productDetails, wrapupAddonRedesign,
}) => {
    const isMobile = useMediaQuery('(max-width: 600px)');
    useEffect(() => {
        // Adding the overflow initial in the main div of the body tag,
        // because was not allowing to create the sticky button in the button
        if (
            typeof document !== 'undefined'
            && document.getElementById('root')
            && document.getElementById('root').style
            && document.getElementById('root').style.overflow !== 'initial'
        ) {
            document.getElementById('root').style.overflow = 'initial';
        }
    }, []);
    const classes = useStyle();
    const addToCheck = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.7071 5.29289C21.0976 5.68342 21.0976 6.31658 20.7071 6.70711L9.70711 17.7071C9.51957 17.8946 9.26522 18 9 18C8.73478 18 8.48043 17.8946 8.29289 17.7071L3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929C3.68342 10.9024 4.31658 10.9024 4.70711 11.2929L9 15.5858L19.2929 5.29289C19.6834 4.90237 20.3166 4.90237 20.7071 5.29289Z" fill="#21571D" />
        </svg>
    );
    return (
        <div className={classes.addonWrapper}>
            {isMobile &&  <div className={classes.titleProd}><strong>Added to Cart<span className={classes.iconCheck}>{addToCheck()}</span></strong></div>}
            <div className={classes.productDetail}>
                <CurrentProduct productDetails={productDetails} wrapupAddonRedesign={wrapupAddonRedesign} isMobile={isMobile} />
            </div>
        </div>
    );
};
AddonProductInfoUI.propTypes = {
    productDetails: object,
    wrapupAddonRedesign: bool,
};
AddonProductInfoUI.defaultProps = {
    productDetails: {},
    wrapupAddonRedesign: false,
};

export default AddonProductInfoUI;
